module.exports = __webpack_public_path__ + "cee9d8112262cfc008a2e4affd7f1ff2.png";